// extracted by mini-css-extract-plugin
export default {"status_published_label":"styles_status_published_label__1iHdy","status_before_publish_label":"styles_status_before_publish_label__K4PUb"};